module.exports = __webpack_public_path__ + "img/oem-yacht.e6444ab3.jpg";